import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Card,
  CardContent,
  Chip,
  Button,
  Divider,
} from '@mui/material';
import { ArrowBack, Share, Edit } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';

const ShiftDetails: React.FC = () => {
  const navigate = useNavigate();
  const { /* id */ } = useParams();

  const shift = {
    id: 1,
    date: 'February 26, 2024',
    time: '07:00 - 15:00',
    type: 'Morning Shift',
    department: 'ICU',
    position: 'Senior Nurse',
    status: 'confirmed',
    hours: 8,
    breakDuration: '30 min',
    notes: 'Regular shift. Team lead: Sarah Johnson',
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a1a2e' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, fontWeight: 700, flexGrow: 1 }}>
            Shift Details
          </Typography>
          <IconButton color="inherit">
            <Share />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box sx={{ p: 2 }}>
        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent sx={{ textAlign: 'center', py: 3 }}>
            <Chip
              label={shift.status}
              color="success"
              sx={{ mb: 2, fontWeight: 600 }}
            />
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#E91E63', mb: 1 }}>
              {shift.time}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
              {shift.date}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {shift.type}
            </Typography>
          </CardContent>
        </Card>

        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              ASSIGNMENT
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography>Department</Typography>
              <Typography fontWeight={600}>{shift.department}</Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography>Position</Typography>
              <Typography fontWeight={600}>{shift.position}</Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography>Hours</Typography>
              <Typography fontWeight={600}>{shift.hours} hours</Typography>
            </Box>
          </CardContent>
        </Card>

        <Card sx={{ mb: 2, borderRadius: 3 }}>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              DETAILS
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography>Break Duration</Typography>
              <Typography fontWeight={600}>{shift.breakDuration}</Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, mb: 1 }}>
              Notes
            </Typography>
            <Typography variant="body2">{shift.notes}</Typography>
          </CardContent>
        </Card>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<Edit />}
            sx={{ py: 1.5 }}
          >
            Edit Availability
          </Button>
          <Button
            fullWidth
            variant="contained"
            sx={{ py: 1.5, bgcolor: '#E91E63' }}
          >
            Request Swap
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ShiftDetails;
